module.exports = __webpack_public_path__ + "static/media/0_2019_07_01-5.c4dc0f26.jpg";